import { ValidationResult } from '../validations/types'
import { NctsPhase, NctsScope } from '../../../../shared/ncts/types'
import { validateTransitOperation } from '../../transit-operation/api/validateTransitOperation'

function useValidateDeclaration(transitOperationId: number | null) {
  const validateTransit = async ({
    phase,
    isOptIn,
    scope,
  }: {
    phase: NctsPhase
    isOptIn: boolean
    scope?: NctsScope
  }): Promise<ValidationResult> => {
    if (!transitOperationId) throw new Error('Missing transit operation ID')

    return await validateTransitOperation(transitOperationId, { phase, scope, isOptIn })
  }

  return {
    validateDeclaration: validateTransit,
    isLoading: false,
  }
}

export default useValidateDeclaration
